import useMemberSettings from '../member/useMemberSettings';

export default function useBudgetSettings() {
  const memberSettings = useMemberSettings();
  return memberSettings?.web?.features?.budgets;
}
